import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const InvoiceDateHeader = ({ column }: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Re.Datum"
      style={{ padding: "5px" }}
    />
  );
};
